import { useState } from 'react';
import { Button, Space } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import { useReviewActions } from '@/hooks/feedback/useReviewActions';
import { RejectReviewModal } from '@/components/feedback/RejectReviewModal';

interface ReviewActionButtonsProps {
  reviewId?: string | number;
  isAccepted?: boolean;
  isRejected?: boolean;
}

export const ReviewActionButtons = ({
  reviewId,
  isAccepted,
  isRejected,
}: ReviewActionButtonsProps) => {
  const t = useTranslate();
  const actions = useReviewActions({ reviewId });
  const [rejectOpen, setRejectOpen] = useState(false);

  const showAccept = isAccepted !== true;
  const showReject = isRejected !== true;

  return (
    <Space>
      {showAccept && (
        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={actions.accept.mutate}
          loading={actions.accept.isLoading}
        >
          {t('feedback.reviews.actions.accept')}
        </Button>
      )}

      {showReject && (
        <Button
          danger
          icon={<CloseOutlined />}
          onClick={() => setRejectOpen(true)}
          loading={actions.reject.isLoading}
        >
          {t('feedback.reviews.actions.reject')}
        </Button>
      )}

      <RejectReviewModal
        open={rejectOpen}
        submitting={actions.reject.isLoading}
        onCancel={() => setRejectOpen(false)}
        onSubmit={(reason) =>
          actions.reject.mutate(reason, () => setRejectOpen(false))
        }
      />
    </Space>
  );
};
